import { createSlice } from "@reduxjs/toolkit";
import { IResourceUI } from "./types/Resources.interface";
import { getComercialInvoicePDF, getInvoicePDF } from "./resources.action";

const initialState: IResourceUI = {
  ui: { loading: false, resource: {} },
};

export const resourcesSlice = createSlice({
  name: "resources",
  initialState,
  reducers: {
    clearFileUrl: (state) => {
      state.ui.resource.fileUrl = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoicePDF.pending, (state) => {
        state.ui.loading = true;
        state.ui.resource.fileUrl = undefined;
      })
      .addCase(getInvoicePDF.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.resource.fileUrl = action.payload;
      })
      .addCase(getInvoicePDF.rejected, (state) => {
        state.ui.loading = false;
      })
      .addCase(getComercialInvoicePDF.pending, (state) => {
        state.ui.loading = true;
        state.ui.resource.fileUrl = undefined;
      })
      .addCase(getComercialInvoicePDF.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.resource.fileUrl = action.payload;
      })
      .addCase(getComercialInvoicePDF.rejected, (state) => {
        state.ui.loading = false;
      });
  },
});

export const { clearFileUrl } = resourcesSlice.actions;
